<template>
    <div>
        <label class="block text-sm font-medium text-gray-700">Etagen</label>
        <select-menu v-model="local" v-show="hasFloors"
                    :text="text"
                    :values="values">
            <span v-show="!filter">Etage</span>
        </select-menu>
    </div>
</template>

<script>
import SelectMenu from "./UI/SelectMenu";

export default {
    name: "FloorSelect",

    components: {SelectMenu},

    props: {
        value: {},
        filter: {
            default: false,
        },
    },

    inject: ['group'],

    computed: {
        floors() {
            // sort floors by name
            return this.group.floors.sort((a, b) => a.name.localeCompare(b.name));
        },
        text() {
            return ['Alle'].concat(this.floors.map(p => p.name));
        },
        values() {
            return [null].concat(this.floors.map(p => p.id));
        },
        hasFloors() {
            return this.floors.length > 0;
        },
        local: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value !== "" ? parseInt(value) : null);
            },
        },
    }
}
</script>

<style scoped>

</style>